var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetappOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 380,
    viewBox: "0 0 720 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-182.053 -818.488C-182.053 -818.488 1743.65 -922.28 1869.47 -929.062C1995.29 -935.843 2265.78 43.0273 1934.78 282.527C1603.78 522.027 690.275 225.576 -85.1292 369.016C-860.533 512.456 -182.053 -818.488 -182.053 -818.488Z",
    fill: "url(#paint0_linear_7190_127162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7190_127162",
    x1: 774.426,
    y1: -870.041,
    x2: 843.798,
    y2: 417.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC686E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83F45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetappOverlay);
export default __webpack_public_path__ + "static/media/getapp-overlay.dcd7802c36cfe59165c20f48512242b0.svg";
export { ForwardRef as ReactComponent };